import insertRecipientsShownAtFront from './insertRecipientsShownAtFront';
import AtMentionsViewState from '../store/schema/AtMentionsViewState';
import getAndPopulateSuggestedContacts from 'owa-recipient-cache/lib/actions/getAndPopulateSuggestedContacts';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import setIsSearching from './setIsSearching';
import { action } from 'satcheljs/lib/legacy';

export default action('setSuggestedContacts')(function setSuggestedContacts(
    viewState: AtMentionsViewState,
    currentWellContents?: ReadWriteRecipientViewState[]
) {
    getAndPopulateSuggestedContacts(viewState.findResultSet);
    if (currentWellContents) {
        insertRecipientsShownAtFront(viewState.findResultSet, currentWellContents, 5);
    }
    setIsSearching(viewState, false /* isSearching */);
});
